import { DetailDialogController } from '../../../controller/DetailDialogController';
import { accounts, ADMINISTRATION_USER_ACC } from '../../../services/arsweb/RoutingPaths';
import { BackendService } from '../../../services/BackendService';

import './account.html';
import './detail.html';
import './addAccount.html';

/** @ngInject */
export class AccountDetailDialogController extends DetailDialogController {

    constructor($scope, userService, arsMainDependencies, createOrUpdateFunction) {
        super($scope, userService, arsMainDependencies, accounts, new BackendService(userService, ADMINISTRATION_USER_ACC));

        this.createOrUpdateFunction = createOrUpdateFunction;
    }

    save() {
        if(this.$scope.detailForm.$valid) {

            this.element.filter = null;

            if (this.selectAllType === 'GLOBAL') {
                if (!this.filter) {
                    this.infoPop("SELECT_ALL_GLOBAL_WITH_FILTER");
                    return;
                }

                this.element.filter = this.filter;
            }

            return this.update();
        } else {
            this.infoPop('MISSING_MANDATORY');
        }
    }

    populateIfEmpty(fieldValue, populationValue, targetField) {
        this.ftsMainDependencies.$timeout(() =>
                this.populateTheField( fieldValue, populationValue, targetField), 500);
    }

    populateTheField( fieldValue, populationValue, targetField) {
        if(fieldValue.$viewValue === '') {
            this.element[targetField] = populationValue;
        }
    }

    // The id for an account is the load key. Unfortunately, some may contain '/' making it impossible to use id in the url
    update() {
        if((this.element.shortName && this.validateCharacters(this.element.shortName)) ||
            (this.element.userDefinedAlias1  && this.validateCharacters(this.element.userDefinedAlias1))) {
            this.errorPop("SPECIAL_CHARACTERS_VALID");
        } else {
            const updateElement = {shortName: this.element.shortName, userDefinedAlias1: this.element.userDefinedAlias1,
                accountName: this.element.accountName};
            return this.detailviewDataPromise = this.service.putUserData(this.restUrl, updateElement)
                .then(data => this.handleUpdate(data))
                .then(() => this.closeDialog())
                .catch(() => this.errorPop('UPDATE_ERROR'));
        }
    }

    loadElement() {
        return this.detailviewDataPromise = this.service.getUserData(this.restUrl + "/details", '')
            .then(data => this.handleLoad(data));
    }

    validateCharacters(val) { // invalid chars: $, }, \
        return /[$}\\]/.test(val);
    }
}
